export default __webpack_public_path__ + "static/step4-4d86da63dd027876bda719fe9824af82.webp";